import { fetchAuthSession } from 'aws-amplify/auth';

export const getAuthHeader = async () => {
  const session = await fetchAuthSession();
  const token   = session.tokens?.idToken?.toString();
  if (!token) throw new Error('Session expired');
  return { Authorization: token };
};

export const normalizePhone = (phone) => {
  const digits = phone.replace(/\D/g, '');
  if (digits.startsWith('91') && digits.length === 12) return `+${digits}`;
  return `+91${digits}`;
};

export const parseResponse = (res) => {
  try {
    if (!res || !res.data) return {};

    const data = res.data;

    // Already a plain object without Lambda wrapper
    if (typeof data === 'object' && !data.statusCode && !data.body) {
      return data;
    }

    // Lambda proxy response — body is a string
    if (data.body && typeof data.body === 'string') {
      return JSON.parse(data.body);
    }

    // Body already parsed
    if (data.body && typeof data.body === 'object') {
      return data.body;
    }

    // Raw string
    if (typeof data === 'string') {
      return JSON.parse(data);
    }

    return data;

  } catch (err) {
    console.error('parseResponse error:', err, 'raw:', res?.data);
    return {};
  }
};